import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';

import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { messages } from './messages';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from '../Search/reducer';
import saga from '../Search/saga';

import { makeSelectSelectedParams } from '../Search/selectors';
import { updateParam } from '../Search/actions';

import { InputNumber } from 'antd';
import { InputSlider } from '../UIKit';
import { getObjByAttribute } from '../../utils/common';

import './styles.scss';

import _ from 'lodash';

class RangeSlider extends React.Component {
  constructor(props) {
    super(props);

    let [start, end] = props.value

    if (props.items) {
      [start, end] = this.getNumericValuesFromString([start, end])
    }

    this.state = {
      additionalSteps: [],
      start: parseInt(start),
      end: parseInt(end),
      onAfterChangePending: false,
    };

    this.sliderRef = React.createRef();

    this.id = _.uniqueId();

  }

  getNumericValuesFromString = values => {
    const { items } = this.props
    let [start, end] = values

    if (items) {
      start = typeof start === 'string' ? parseInt(
        Object
          .keys(items)
          .find(key => items[key].label === start || items[key].label === this.formatValueLabel(start))
        ) : start;
      end = typeof end === 'string' ? parseInt(
        Object
          .keys(items)
          .find(key => items[key].label === end || items[key].label === this.formatValueLabel(end))
        ) : end;
    }

    return [start, end];
  }

  get minMax() {
    let { min, max, items } = this.props;

    if (items && (!min || !max)) {
      min = parseInt(Object.keys(items)[0]);
      max = parseInt(Object.keys(items).slice(-1)[0]);
    }

    return [min, max];
  }

  onChange = values => {
    const { items } = this.props
    let [start, end] = values

    if (items) {
      [start, end] = this.getNumericValuesFromString([start, end])
    }

    this.setState({ start, end })
  };

  onAfterChange = value => {
    const { onAfterChangePending } = this.state;

    if (!onAfterChangePending) {
      const {onChange, name, items, label, selectedParams, hasConfirmMessage } = this.props

      this.setState({onAfterChangePending: true}, () => {
        if (!hasConfirmMessage || (hasConfirmMessage && confirm(messages.confirmMessageEdit))) {
          const [min, max] = this.minMax
          let [start, end] = value
          let [selectedStart, selectedEnd] = [min, max]

          const current = getObjByAttribute(selectedParams, 'name', name)

          if (current && current.value) {
            [selectedStart, selectedEnd] = current.value
          }

          if (min !== start || max !== end || start !== selectedStart || end !== selectedEnd) {
            if (items) {
              // valori formattati
              [start, end] = Object.values(value.reduce((obj, key) => ({...obj, [key]: items[key].label}), {}))
            }

            if (typeof end === 'undefined') {
              end = start
            }

            onChange(label, name, start, end)
            this.setState({onAfterChangePending: false});
          }
        } else {
          const [start, end] = this.props.value;
          this.sliderRef.current.blur();
          this.setState({
            onAfterChangePending: false,
            start: parseInt(start),
            end: parseInt(end)
          });
        }
      });
    }
  };

  onStartChange = startValue => {
    const [min, max] = this.minMax
    startValue = parseInt(`${startValue}`.replace('.', ''))

    if (startValue && !isNaN(startValue) && startValue >= min && startValue <= this.state.end && startValue <= max) {
      this.setState(
        {
          start: parseInt(startValue),
          additionalSteps: [...this.state.additionalSteps, parseInt(startValue)],
        },
        () => {
          const {start, end} = this.state
          this.onAfterChange([start, end])
        }
      )
    }
  };

  onStartChangeDebounced = AwesomeDebouncePromise(
    this.onStartChange,
    500,
    { key: () => `${this.props.name}startValue` },
  )

  onEndChange = endValue => {
    const [min, max] = this.minMax
    endValue = parseInt(`${endValue}`.replace('.', ''))

    if (endValue && !isNaN(endValue) && endValue >= min && endValue >= this.state.start && endValue <= max) {
      this.setState(
        {
          end: parseInt(endValue),
          additionalSteps: [...this.state.additionalSteps, parseInt(endValue)],
        },
        () => {
          const {start, end} = this.state
          this.onAfterChange([start, end])
        }
      );
    }
  };

  onEndChangeDebounced = AwesomeDebouncePromise(
    this.onEndChange,
    500,
    { key: () => `${this.props.name}endValue` },
  )

  formatValueLabel = value => {
    const { items, labelFormatter, unit } = this.props

    if (typeof labelFormatter === 'function') {
      return labelFormatter(value, unit);
    } else {
      if (items && items[value] && items[value].label) {
        return items[value].label;
      }

      return `${value}${unit ? ` ${unit}` : ''}`;
    }
  };

  render() {
    const {
      label,
      labelShort,
      unit,
      step,
      items,
      withInput,
      withStepLabel,
      addOn,
      disabled
    } = this.props;

    const { additionalSteps, start, end } = this.state;

    const [min, max] = this.minMax;
    let componentId = `search-filters-range-slider-${label}-${this.id}`.replace(/\s+/g, '-').toLowerCase();;

    return (
      <div className="mb-3">
        <h4 className="todo-sidebar-section-header">
          <div className="range-slider-label-container">
            <label id={`label-${componentId}`} htmlFor={componentId} className='mb-0'>
              <span className="d-none d-xl-inline d-xxl-none">{labelShort || label}</span>
              <span className="d-inline d-xl-none d-xxl-inline">{label}</span>
            </label>
            {addOn &&
              <span className="pull-right small">
                {addOn}
              </span>
            }
          </div>
          {withInput ? (
            <div className="pull-right mt-2" id={componentId} aria-labelledby={`label-${componentId}`}>
              <label htmlFor={`min-input-${label}`} className="mb-0 sr-only sr-only-focusable">
                {`min-input-${componentId}`}
              </label>
              <InputNumber
                size="small"
                formatter={value =>
                  value !== unit ? `${unit} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : ''
                }
                parser={value => value.replace(`${unit} `, '').replace(/\$\s?|(\.*)/g, '')}
                min={min}
                max={max}
                disabled={min === max}
                value={start}
                step={step}
                onChange={this.onStartChangeDebounced}
                className="range-slider-input range-slider-input-start"
                id={`min-input-${componentId}`}
                aria-label={`Minimo ${label}`}
              />
              -
              <label htmlFor={`max-input-${componentId}`} className="mb-0 sr-only sr-only-focusable">
                {`max-input-${componentId}`}
              </label>
              <InputNumber
                size="small"
                formatter={value =>
                  value !== unit ? `${unit} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.') : ''
                }
                parser={value => value.replace(`${unit} `, '').replace(/\$\s?|(\.*)/g, '')}
                min={min}
                max={max}
                disabled={min === max}
                value={end}
                step={step}
                onChange={this.onEndChangeDebounced}
                className="range-slider-input range-slider-input-end"
                id={`max-input-${componentId}`}
                aria-label={`Massimo ${label}`}
              />
            </div>
          ) : !withStepLabel ? (
            <div className="pull-right range-label-start-end mt-3">
              {this.formatValueLabel(start)}
              {` - `}
              {this.formatValueLabel(end)}
            </div>
          ) : null}
        </h4>
        <InputSlider
          disabled={disabled}
          min={min}
          max={max}
          steps={items}
          value={[start, end]}
          step={step}
          additionalSteps={additionalSteps}
          onChange={this.onChange}
          onAfterChange={this.onAfterChange}
          labelFormatter={this.formatValueLabel}
          withStepLabel={withStepLabel}
          ref={this.sliderRef}
          id={`range-slider-label-${componentId}`}
          ariaLabel={`Slider ${label}`}
        />
      </div>
    );
  }
}

RangeSlider.defaultProps = {
  withInput: false,
  withStepLabel: true,
  disabled: false
};

RangeSlider.propTypes = {
  label: PropTypes.string.isRequired,
  labelShort: PropTypes.string,
  name: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  items: PropTypes.object,
  step: PropTypes.number,
  value: PropTypes.array,
  onChange: PropTypes.func,
  unit: PropTypes.string,
  withInput: PropTypes.bool,
  withStepLabel: PropTypes.bool,
  hasConfirmMessage: PropTypes.bool,
  labelFormatter: PropTypes.func,
  addOn: PropTypes.any,
  disabled: PropTypes.bool
};

const mapStateToProps = createStructuredSelector({
  selectedParams: makeSelectSelectedParams(),
});

export function mapDispatchToProps(dispatch) {
  return {
    updateValue: values => dispatch(updateParam(values)),
  };
}

const withReducer = injectReducer({ key: 'search', reducer });
const withSaga = injectSaga({ key: 'search', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(RangeSlider);
